export const manifest = {
  screens: {
    scr_8hhe5u: { name: "Time with Solventum pays back", route: "/", state: {"slideIndex":0}, position: {"x":2960,"y":220} },
    scr_prb002: { name: "HCP attention is expensive", route: "/", state: {"slideIndex":1}, position: {"x":160,"y":220} },
    scr_prm003: { name: "Give us a little time", route: "/", state: {"slideIndex":2}, position: {"x":1560,"y":220} },
    scr_fmt004: { name: "The countdown becomes the signal", route: "/", state: {"slideIndex":3}, position: {"x":4360,"y":220} },
    scr_prf005: { name: "Already in use", route: "/", state: {"slideIndex":4}, position: {"x":5760,"y":220} },
    scr_amb006: { name: "From campaign recognition to brand trust", route: "/", state: {"slideIndex":5}, position: {"x":7160,"y":220} },
  },
  sections: {
    sec_22akog: { name: "Solventum value proposition", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_22akog", children: [
      { kind: "screen", id: "scr_prb002" },
      { kind: "screen", id: "scr_prm003" },
      { kind: "screen", id: "scr_8hhe5u" },
      { kind: "screen", id: "scr_fmt004" },
      { kind: "screen", id: "scr_prf005" },
      { kind: "screen", id: "scr_amb006" },
    ] },
  ],
}
